import { useState } from 'react'
import { useEffectOnce } from 'usehooks-ts'
import styled from 'styled-components'
import ColumnChart from 'components/ColumnChart'

const GridItem = ({
  tenant,
  colorMode,
  name,
  data,
  index,
  colors,
  iso,
  activeTooltip,
  setActiveTooltip,
}: {
  tenant?: object
  colorMode?: string
  name: string
  data: any
  index: number
  colors: object
  iso: string
  activeTooltip: any
  setActiveTooltip: any
}) => {
  const [isMobile, setIsMobile] = useState(false)

  const handleResize = (): void => {
    setIsMobile(window.innerWidth < 600)
  }

  /*
  const commatize = (word: any) => {
    const replaced = word.toString().replace('.', ',')
    return replaced.indexOf(',0') > 1 && replaced.slice(-2) === ','
      ? replaced.replace(',0', '')
      : replaced
  }
  */

  useEffectOnce(() => {
    // set height when window is resized
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  })

  return (
    <Griditem className={isMobile ? 'mobile' : 'desktop'}>
      <h4 lang='de'>
        <span className='flag'>
          <img src={require('../../images/' + iso + '.svg')} alt={iso} />
        </span>
        <span
          className='name'
          dangerouslySetInnerHTML={{
            __html: name,
          }}
        />{' '}
      </h4>
      <div className='graphic'>
        <ColumnChart
          data={data}
          index={index}
          colorMode={colorMode}
          colors={colors}
          iso={iso}
          activeTooltip={activeTooltip}
          setActiveTooltip={setActiveTooltip}
        />
      </div>
    </Griditem>
  )
}
const Griditem = styled.div`
  color: var(--text-color);

  h4 {
    position: relative;
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 2rem;
    @media only screen and (max-width: 600px) {
      font-size: 1.4rem;
      line-height: 1.9rem;
    }
    text-align: center;
    margin: 0 0 0.8rem;
    width: 100%;

    .flag,
    .name {
      display: inline-block;
    }

    .flag {
      img {
        width: 1.5rem;
        height: auto;
        margin-right: 0.8rem;
        top: 0.2rem;
        position: relative;
        border: 1px solid var(--flag-border);
        filter: saturate(85%);
      }
    }

    -webkit-hyphens: auto;
    -moz-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
  }
  .graphic {
    position: relative;
  }
`

export default GridItem
